/**
 * Drawer Portal - Relocates drawers to body to escape stacking context
 *
 * Problem: The .animation-section has `isolation: isolate` which creates a new
 * stacking context. Fixed-position drawers inside it become relative to the
 * section instead of the viewport, causing z-index issues with other sections.
 *
 * Solution: Move drawer elements to body on page load. This is a one-time
 * relocation - drawers stay at body level and use existing CSS transitions
 * for open/close states.
 */
(function() {
  'use strict';

  function relocateDrawersToBody() {
    // Find all callout sections that may have drawers
    var sections = document.querySelectorAll('.callout-section[data-section-id]');

    sections.forEach(function(section) {
      var sectionId = section.dataset.sectionId;
      if (!sectionId) return;

      // Select all drawer elements for this section
      var drawerElements = [
        document.querySelector('[data-drawer-overlay="' + sectionId + '"]'),
        document.querySelector('[data-drawer-one="' + sectionId + '"]'),
        document.querySelector('[data-drawer-sub="' + sectionId + '"]')
      ];

      // Move each drawer to body if it exists and isn't already there
      drawerElements.forEach(function(drawer) {
        if (drawer && drawer.parentNode !== document.body) {
          document.body.appendChild(drawer);
        }
      });
    });
  }

  // Run on DOMContentLoaded or immediately if DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', relocateDrawersToBody);
  } else {
    relocateDrawersToBody();
  }
})();
